import React, { Component } from 'react'

export default class Header extends Component {
    render() {
        return (
            <div>
                <h1>My Poll Data</h1>
            </div>
        )
    }
}
